(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("dashboard", {
        templateUrl: "app/dashboard/dashboard.component.html",
        controller: ["authService", "frameworkService", "dashboardResource", "accountsResource", "messageService", "$state", "_", DashboardCtrl],
        controllerAs: "vm"
    });
    function DashboardCtrl(authService, frameworkService, dashboardResource, accountsResource, messageService, $state, _) {
        var vm = this;
        vm.test = "Larry was here";
        if (!frameworkService.data.tenantFeatures.dashboard)
            $state.go("main.notFound");
        vm.isReadOnly = $state.params.isReadOnly;
        vm.loading = true;
        vm.isPhone = jQuery.browser.mobile;
        if (vm.isReadOnly) {
            vm.person = $state.params.personSeq;
            accountsResource.getName({ personSeq: vm.person }, function (data) {
                vm.fullName = data.value;
            });
            dashboardResource.get({ personSeq: vm.person }, function (data) {
                //vm.isLearner = _.includes(data.roles, "Learner");
                vm.isSuperAdmin = _.includes(data.roles, "Super Admin");
                vm.isAdmin = vm.isSuperAdmin || _.includes(data.roles, "Site Admin") || _.includes(data.roles, "Group Admin") || _.includes(data.roles, "Organization Admin");
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
        }
        else {
            //vm.isLearner = authService.authentication.isLearner;
            vm.isSuperAdmin = authService.isSuperAdmin();
            vm.isAdmin = authService.isGroupOrOrgAdmin() || authService.isSiteAdmin() || authService.isSuperAdmin();
            vm.loading = false;
        }
    }
}());
